/* eslint-disable react/no-unescaped-entities */
import * as React from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { useDispatch, useSelector } from '../../redux/store'
import Autocomplete from "@mui/material/Autocomplete";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import parse from "autosuggest-highlight/parse";
import { debounce } from "@mui/material/utils";
import PublicIcon from "@mui/icons-material/Public";
import {
  InputAdornment,
} from "@mui/material";
import { getHotelList, activityDetails } from '../../redux/slices/activity'
const GOOGLE_MAPS_API_KEY = process.env.MAPKEY;

function loadScript(src, position, id) {
  if (!position) {
    return;
  }

  const script = document.createElement("script");
  script.setAttribute("async", "");
  script.setAttribute("id", id);
  script.src = src;
  position.appendChild(script);
}

const autocompleteService = { current: null };

export default function PickupLocation({
  type,
  pickup,
  drop,
  setPickup,
  setDrop,
  label,
  placeholder, activityId
}) {

  const dispatch = useDispatch();
  const [value, setValue] = React.useState(null);
  const [inputValue, setInputValue] = React.useState("");
  const [options, setOptions] = React.useState([]);
  const loaded = React.useRef(false);
  const [activityData, setActivityData] = React.useState(null)
  const { activityDetailsRes } = useSelector(state => state.activity)

  React.useEffect(() => {
    if (activityId) {
      dispatch(activityDetails({ activityId: activityId }))
    }
  }, [activityId])

  function extractCityNames(dataArray) {
    return dataArray?.map(item => item.name || item.cityName?.cityName).filter(Boolean);
  }


  React.useEffect(() => {
    if (activityDetailsRes) {
      if (Object.keys(activityDetailsRes).length === 0) {
      } else {
        const cityNames = extractCityNames(activityDetailsRes?.pickupPoint);
        setActivityData(cityNames)
      }
    }
    return () => { }
  }, [activityDetailsRes])

  if (typeof window !== "undefined" && !loaded.current) {
    if (!document.querySelector("#google-maps")) {
      loadScript(
        `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&libraries=places`,
        document.querySelector("head"),
        "google-maps"
      );
    }

    loaded.current = true;
  }

  const fetch = React.useMemo(
    () =>
      debounce((request, callback) => {
        request.componentRestrictions = { country: "ae" };

        autocompleteService.current.getPlacePredictions(request, (results) => {
          if (!results) {
            callback([]);
            return;
          }

          const filteredResults = Array.isArray(activityData) && activityData.length > 0
            ? results.filter((place) =>
              activityData.some((city) =>
                place.description.toLowerCase().includes(city.toLowerCase())
              )
            )
            : results;

          callback(filteredResults);
        });
      }, 400),
    [activityData]
  );




  React.useEffect(() => {
    let active = true;

    if (!autocompleteService.current && window.google && window.google.maps && window.google.maps.places) {
      autocompleteService.current = new window.google.maps.places.AutocompleteService();
    }
    if (!autocompleteService.current) {
      return undefined;
    }

    if (inputValue === "") {
      setOptions(value ? [value] : []);
      return undefined;
    }

    fetch({ input: inputValue }, (results) => {
      if (active) {
        let newOptions = [];

        if (value) {
          newOptions = [value];
        }

        if (results) {
          newOptions = [...newOptions, ...results];
        }

        setOptions(newOptions);
      }
    });

    return () => {
      active = false;
    };
  }, [value, inputValue, setOptions, setValue]);

  return (
    <Box className={`searchMenu-loc lg:px-0 js-form-dd`} sx={{
      "& label.Mui-focused": {
        color: "black",
      },
      "& .MuiAutocomplete-clearIndicator": {
        display: "none",
      },
      "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
        border: "1px solid rgba(0, 0, 0, 0.5)",
      },
      "& .MuiInput-underline:after": {
        border: "1px solid rgba(0, 0, 0, 0.5)",
      },
      "& .MuiAutocomplete-listbox": {
        overflow: "hidden",
      },
      "& .MuiOutlinedInput-root": {
        "& fieldset": {
          border: "1px solid rgba(0, 0, 0, 0.5)",
          borderRadius: "8px",
        },
        "&:hover fieldset": {
          border: "1px solid rgba(0, 0, 0, 0.5)",
        },
        "&.Mui-focused fieldset": {
          border: "1px solid rgba(0, 0, 0, 0.5)",
        },
      },
      "&::-webkit-scrollbar": {
        width: "2px",
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "#888",
        borderRadius: "6px",
      },
      "&::-webkit-scrollbar-thumb:hover": {
        backgroundColor: "#555",
      },
    }}>
      <Autocomplete
        id="google-map-demo"
        getOptionLabel={(option) =>
          typeof option === "string" ? option : option.description
        }
        noOptionsText={
          options.length === 0 ? <div style={{
            padding: "16px",
            textAlign: "center",
            color: "#666",
            fontSize: "14px",
            backgroundColor: "#f8f9fa",
            borderRadius: "8px"
          }}>
            <p style={{ marginTop: "5px" }}>
              Please search your {type} location
            </p>
          </div> :
            <div style={{
              padding: "16px",
              textAlign: "center",
              color: "#666",
              fontSize: "14px",
              backgroundColor: "#f8f9fa",
              borderRadius: "8px"
            }}>
              <strong style={{ fontSize: "16px", color: "#333" }}>
                No results found
              </strong>
              <p style={{ marginTop: "5px" }}>
                Please check the airport or city you have entered or select one from the list.
              </p>
            </div>
        }
        options={options}
        autoComplete
        includeInputInList
        filterSelectedOptions
        value={type === "pickup" ? pickup : drop}
        onChange={(event, newValue) => {
          if (newValue !== null) {
            setOptions(newValue ? [newValue, ...options] : options);
            setValue(newValue);
            if (type === "pickup") {
              setPickup(newValue.description);
            } else {
              setDrop(newValue.description);
            }
          }
        }}
        onInputChange={(event, newInputValue) => {
          setInputValue(newInputValue);
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            placeholder={placeholder}
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <InputAdornment position="start">
                  <PublicIcon />
                </InputAdornment>
              ),
            }}
            fullWidth
          />
        )}
        renderOption={(props, option) => {
          const matches =
            option.structured_formatting.main_text_matched_substrings || [];

          const parts = parse(
            option.structured_formatting.main_text,
            matches.map((match) => [match.offset, match.offset + match.length])
          );

          return (
            <li {...props}>
              <Grid container alignItems="center">
                <Grid item sx={{ display: "flex", width: 44 }}>
                  <LocationOnIcon sx={{ color: "text.secondary" }} />
                </Grid>
                <Grid
                  item
                  sx={{ width: "calc(100% - 44px)", wordWrap: "break-word" }}
                >
                  {parts.map((part, index) => (
                    <Box
                      key={index}
                      component="span"
                      sx={{ fontWeight: part.highlight ? "bold" : "regular" }}
                    >
                      {part.text}
                    </Box>
                  ))}

                  <Typography variant="body2" color="text.secondary">
                    {option.structured_formatting.secondary_text}
                  </Typography>
                </Grid>
              </Grid>
            </li>
          );
        }}
      />
    </Box>
  );
}
